// Navigation.tsx
import React from "react";
import Link from "next/link";
import { NavHeading, NavigationContainer, NavLink, NavSection } from "./BlogNavigation.styled";
interface BlogNavigationProps {
  previous?: {
    slug: string;
    title: string;
  } | null;
  next?: {
    slug: string;
    title: string;
  } | null;
}
const BlogNavigation: React.FC<BlogNavigationProps> = ({
  previous,
  next
}) => {
  return <NavigationContainer data-sentry-element="NavigationContainer" data-sentry-component="BlogNavigation" data-sentry-source-file="index.tsx">
            {previous && <NavSection className="previous">
                    <NavHeading>Previous</NavHeading>
                    <Link href={`/blogs/${previous.slug}`} passHref>
                        <NavLink>{previous.title}</NavLink>
                    </Link>
                </NavSection>}
            {next && <NavSection className="next">
                    <NavHeading>Next</NavHeading>
                    <Link href={`/blogs/${next.slug}`} passHref>
                        <NavLink>{next.title}</NavLink>
                    </Link>
                </NavSection>}
        </NavigationContainer>;
};
export default BlogNavigation;